import { createContext, useContext } from "react";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
// // store
import CommonStoreTypes from "src/store/types/common-store";
import CartStoreTypes from "src/store/types/cart-store";
import OrderStoreTypes from "src/store/types/order-store";
import ContactStoreTypes from "src/store/types/contact-store";

export class RootStore {
  commonStore: CommonStoreTypes = null;
  cartStore: CartStoreTypes = null;
  orderStore: OrderStoreTypes = null;
  contactStore: ContactStoreTypes = null;

  constructor() {
    this.commonStore = new CommonStoreTypes();
    this.cartStore = new CartStoreTypes();
    this.orderStore = new OrderStoreTypes();
    this.contactStore = new ContactStoreTypes();
  }
}

const rootStore = new RootStore();
const StoreContext = createContext<RootStore>(new RootStore());

export interface IResponse {
  success;
  message;
  data;
}

export { rootStore, StoreContext, runInAction, observer };

export default {};
